import React, {useContext} from 'react';
import {
  Box,
  Flex,
  Avatar,
  AvatarBadge,
  Heading,
  Text,
  VStack,
  Icon,
  Button,
  Card,
  CardHeader,
  CardBody,
  SimpleGrid,
  Divider,
} from '@chakra-ui/react';

import { AuthContext } from "../context/AuthContext";
import { useAuth } from '../context/AuthContext'; // ต้องมั่นใจว่า path ถูกต้อง
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import ตัวหลัก
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaBirthdayCake, FaUserTie, FaBuilding, FaUserCheck } from 'react-icons/fa';

// ฟังก์ชันสำหรับจัดรูปแบบวันที่
const formatDate = (isoDate) => {
  if (!isoDate) return '-';
  const date = new Date(isoDate);
  return date.toLocaleDateString('th-TH', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

const InfoRow = ({ icon, label, value }) => (
  <Flex align="center">
    <Icon as={icon} color="gray.500" mr={4} />
    <Box>
      <Text fontSize="sm" color="gray.600">
        {label}
      </Text>
      <Text fontWeight="medium">{value || '-'}</Text>
    </Box>
  </Flex>
);

const UserProfile = () => {
  const { profile } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!profile) {
    return <Text>ไม่พบข้อมูลผู้ใช้</Text>;
  }

  const fullName = `${profile.FirstName} ${profile.LastName}`;
  const position = profile.jobdescription || 'เจ้าหน้าที่'; // หากมี jobdescription ในข้อมูลจริง

  return (
    <Box p={{ base: 4, md: 8 }} bg="gray.50" minH="100vh">
      <Flex
        direction={{ base: 'column', lg: 'row' }}
        gap={8}
        maxW="1200px"
        mx="auto"
      >
        {/* === ส่วนซ้าย: รูปภาพและข้อมูลหลัก === */}
        <VStack
          as={Card}
          p={8}
          spacing={4}
          align="center"
          w={{ base: '100%', lg: '350px' }}
        >
          <Avatar
            size="2xl"
            src={profile.ProfileImage}
            name={profile.ProfileImage ? fullName : undefined} // ถ้าไม่มีรูปภาพ จะไม่ส่ง name เข้าไป
            icon={<FontAwesomeIcon icon={faUser} size="2x" />} // กำหนด icon ที่จะใช้แทน
          >
            <AvatarBadge
              boxSize="1.25em"
              bg={profile.Status === 'Active' ? 'green.500' : 'green.500'}
            />
          </Avatar>
          <VStack spacing={1} align="center">
            <Text fontSize="lg">
              {fullName}
            </Text>
            {(profile.Position) &&
              <Text fontSize="md" color="gray.500">
              ตำแหน่ง : {profile.Position}
            </Text>
            }
            {(profile.DepartmentName) &&
              <Text fontSize="md" color="gray.500">
              สังกัด : {profile.DepartmentName}
            </Text>
            }
          </VStack>
          <Button
            colorScheme="gray"
            variant="outline"
            onClick={() => navigate(-1)} // -1 คือการย้อนกลับไปหน้าก่อนหน้า
          >
            ย้อนกลับ
          </Button>
        </VStack>

        {/* === ส่วนขวา: ข้อมูลรายละเอียด === */}
        <Card flex="1">
          <CardHeader>
            <Heading size="md">ข้อมูลส่วนตัว</Heading>
          </CardHeader>
          <Divider color="gray.200" />
          <CardBody>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
              <InfoRow icon={FaEnvelope} label="อีเมล" value={profile.Email} />
              <InfoRow icon={FaPhone} label="เบอร์โทรศัพท์" value={profile.Phone} />
              <InfoRow
                icon={FaMapMarkerAlt}
                label="ที่อยู่"
                value={profile.Address}
              />
              <InfoRow
                icon={FaBirthdayCake}
                label="วันเกิด"
                value={formatDate(profile.BirthDate)}
              />
              <InfoRow
                icon={FaUserTie}
                label="เพศ"
                value={profile.Gender === 'M' ? 'ชาย' : 'หญิง'}
              />
            </SimpleGrid>
          </CardBody>
        </Card>
      </Flex>
    </Box>
  );
};

export default UserProfile;